module.exports = __webpack_public_path__ + "static/img/history.5eb5b33c.svg";